import { constantsData, formFieldNamesData } from "@/data";
import { optionsData } from "@/data/options";
import { AsyncDataKeyEnum, FieldTypeEnum } from "@/enums";

const {
    currency,
    date,
    description,
    status,
} = constantsData.forms.transactions.transaction;

const {
    currency: currencyFieldName,
    date: dateFieldName,
    description: descriptionFieldName,
    status: statusFieldName,
} = formFieldNamesData;

export const transactionFormData = [
    {
        description: date.description,
        label: date.label,
        name: dateFieldName,
        type: FieldTypeEnum.DATE_TIME,
    },
    {
        dataKey: AsyncDataKeyEnum.CURRENCIES,
        description: currency.description,
        isAsync: true,
        label: currency.label,
        name: currencyFieldName,
        type: FieldTypeEnum.SELECT,
    },
    {
        description: status.description,
        hasOptionFormat: true,
        isDisabled: true,
        label: status.label,
        name: statusFieldName,
        options: optionsData.transaction.status.options,
        type: FieldTypeEnum.SELECT,
    },
    {
        description: description.description,
        isOptional: true,
        label: description.label,
        name: descriptionFieldName,
        type: FieldTypeEnum.TEXTAREA,
    },
];
